import { cn } from '@linka/utils';

const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('animate-pulse rounded-md bg-base-gray-200', className)} {...props} />
);

export { Skeleton };
